// Theme tokens — consumed via CSS variables set on <html>
export const themes = {
  dark: {
    '--bg': '#0a0a0f',
    '--bg-2': '#0d0d14',
    '--bg-3': '#13131a',
    '--bg-4': '#1a1a24',
    '--border': 'rgba(255,255,255,0.07)',
    '--border-hover': 'rgba(255,255,255,0.14)',
    '--text-primary': '#f1f5f9',
    '--text-secondary': '#94a3b8',
    '--text-muted': '#475569',
    '--text-faint': '#334155',
    '--card-bg': 'rgba(13,13,20,0.95)',
    '--card-shadow': '0 4px 20px rgba(0,0,0,0.4)',
    '--card-shadow-hover': '0 8px 36px rgba(0,0,0,0.55)',
    '--todo-badge-bg': '#ffffff',
    '--todo-badge-text': '#000000',
    '--toolbar-bg': 'rgba(10,10,15,0.95)',
    '--dot-color': 'rgba(255,255,255,0.04)',
    '--scrollbar-thumb': 'rgba(255,255,255,0.12)',
  },
  light: {
    '--bg': '#f4f5f7',
    '--bg-2': '#ffffff',
    '--bg-3': '#f8f9fa',
    '--bg-4': '#eef0f3',
    '--border': 'rgba(0,0,0,0.08)',
    '--border-hover': 'rgba(0,0,0,0.18)',
    '--text-primary': '#111827',
    '--text-secondary': '#374151',
    '--text-muted': '#6b7280',
    '--text-faint': '#9ca3af',
    '--card-bg': '#ffffff',
    '--card-shadow': '0 2px 12px rgba(0,0,0,0.08)',
    '--card-shadow-hover': '0 6px 28px rgba(0,0,0,0.14)',
    '--todo-badge-bg': '#111111',
    '--todo-badge-text': '#ffffff',
    '--toolbar-bg': 'rgba(255,255,255,0.95)',
    '--dot-color': 'rgba(0,0,0,0.06)',
    '--scrollbar-thumb': 'rgba(0,0,0,0.15)',
  },
};

export function applyTheme(mode) {
  const vars = themes[mode];
  Object.entries(vars).forEach(([k, v]) => {
    document.documentElement.style.setProperty(k, v);
  });
  document.documentElement.setAttribute('data-theme', mode);
}

export function getSystemTheme() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function getSavedTheme() {
  return localStorage.getItem('ideacanvas-theme') || 'system';
}

export function saveTheme(pref) {
  localStorage.setItem('ideacanvas-theme', pref);
}

export function resolveTheme(pref) {
  if (pref === 'system') return getSystemTheme();
  return pref;
}
